import { useMemo } from "react";
import { toLower } from "lodash";
import { when } from "utils";

type IReturnType = { name: string; value: string; category: string; };

export default function useIDType(country: string) {
  const IDMap = {
    primary: [
      { name: "National ID", value: "nationalId", category: "primary" },
      { name: "Voter's Card", value: "votersCard", category: "primary" },
      // {
      //   name: "KRA Certificate",
      //   value: "kraCertificate",
      //   category: "primary", // only for kenya users
      // },
      {
        name: "Driver's License",
        value: "driversLicence",
        category: "primary",
      },
      {
        name: "International Passport",
        value: "passport",
        category: "primary",
      },
      {
        name: "NIMC SLIP",
        value: "nationalSlip",
        category: "primary", // only for nigeria users
      },
      // {
      //   name: "Birth Certificate",
      //   value: "birthCertificate",
      //   category: "primary", // only for kenya users
      // },
    ],
    secondary: [
      { name: "Work ID", value: "work_id", category: "secondary" },
      { name: "Tax Card", value: "tax_card", category: "secondary" },
      {
        name: "Bank Statement",
        value: "bank_statement",
        category: "secondary",
      },
      {
        name: "School ID Card",
        value: "school_id_card",
        category: "secondary",
      },
      {
        name: "Court Affidavit",
        value: "court_affidavit",
        category: "secondary",
      },
      {
        name: "Birth Certificate",
        value: "birth_certificate",
        category: "secondary",
      },
      {
        name: "Marriage Certificate",
        value: "marriage_certificate",
        category: "secondary",
      },
    ],
  };

  const idTypes = useMemo(() => {
    const map: Record<string, IReturnType[]> = {
      nigeria: [...IDMap.primary.filter((d) => !["kraCertificate", "birthCertificate"].includes(d.value))],
      ghana: IDMap.primary.filter((d) => ["passport"].includes(d.value)),
      kenya: IDMap.primary.filter((d) => ["passport"].includes(d.value)),
      "cote d'ivoire": IDMap.primary.filter((d) => ["passport"].includes(d.value)),
      "burkina faso": IDMap.primary.filter((d) => ["passport"].includes(d.value)),
      default: [...IDMap.primary.filter((d) => d.value === "international_passport")],
    };

    const cntry = when(!!country, toLower(country), "nigeria");
    // console.log("ID types - country", country);
    return map[cntry];
  }, [IDMap.primary, country]);

  // console.log("ID types", idTypes, country);

  return idTypes;
}
